module.exports = __webpack_public_path__ + "img/cn1.3a765d6.png";